import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { cachedJsonFetch } from '../../../../../service/cache';
import { fetch_request } from '../../../../../service/request';
import Header from '../Component/Header';
import Paginator from '../Component/Paginator';
import styles from '../Municipality/Index.module.css';
import Content from './Content';

const Index = (props) => {
  const intl = useIntl();
  const [searchInputValue, setSearchInputValue] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const cemeterySlug = props.cemeterySlug;
  const [gravesCount, setGravesCount] = useState(0);
  const [cemeteryName, setCemeteryName] = useState('');
  const [gravesList, setGravesList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchInputValue]);

  useEffect(() => {
    if (!cemeterySlug) return;
    let cancelled = false;

    const loadCount = async () => {
      try {
        const { data } = await cachedJsonFetch(`/api/graves_count?cemetery_slug=${cemeterySlug}`, {
          fetcher: fetch_request,
          cacheKey: `graves-count:${cemeterySlug}`,
          ttlMs: 10 * 60 * 1000,
        });
        if (cancelled) return;
        setGravesCount(data?.count || 0);
      } catch (err) {
        console.log(err);
      }
    };

    loadCount();
    return () => {
      cancelled = true;
    };
  }, [cemeterySlug]);

  useEffect(() => {
    if (!cemeterySlug) return;
    let cancelled = false;

    const loadCemetery = async () => {
      try {
        const { data } = await cachedJsonFetch(`/api/graveyards/${cemeterySlug}`, {
          fetcher: fetch_request,
          cacheKey: `graveyard:slug:${cemeterySlug}`,
          ttlMs: 60 * 60 * 1000,
        });
        if (cancelled) return;
        setCemeteryName(data?.name || '');
      } catch (err) {
        console.log(err);
      }
    };

    loadCemetery();
    return () => {
      cancelled = true;
    };
  }, [cemeterySlug]);

  useEffect(() => {
    if (!cemeterySlug) return;
    let cancelled = false;

    const fetchGraves = async () => {
      setLoading(true);
      const query = new URLSearchParams({
        input: searchInputValue,
        page: String(currentPage),
        cemetery_slug: cemeterySlug,
      });
      const url = `/api/search_graves?${query.toString()}`;
      try {
        const { data } = await cachedJsonFetch(url, {
          fetcher: fetch_request,
          cacheKey: `search-graves:${cemeterySlug}:${searchInputValue || 'all'}:${currentPage}`,
          ttlMs: 5 * 60 * 1000,
        });
        if (cancelled) return;
        setGravesList(data?.graves || []);
        setTotalPages(data?.total_pages || 0);
      } catch (err) {
        console.log(err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchGraves();
    return () => {
      cancelled = true;
    };
  }, [cemeterySlug, currentPage, searchInputValue]);

  const Description = () => {
    return (
      <span className="search-graves_none-text">
        <FormattedMessage id="it_is" />{' '}
        <span>
          <FormattedMessage id="find_grave_count" values={{ count: gravesCount }} />
        </span>{' '}
        <FormattedMessage id="grave_description" />
      </span>
    );
  };
  const headerTitle = cemeteryName || intl.formatMessage({ id: 'graves' });

  return (
    <div className="municipality-index">
      <Header
        title={headerTitle}
        setSearchInputValue={setSearchInputValue}
        placeholder={intl.formatMessage({ id: 'search_grave' })}
        description={<Description />}
      />
      <Content searchInputValue={searchInputValue} list={gravesList} />
      {loading && <div className={styles.loadingHint}><FormattedMessage id="loading" defaultMessage="Loading..." /></div>}
      {gravesCount > 8 && (
        <Paginator
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          totalPages={totalPages}
        />
      )}
    </div>
  );
};

export default Index;
